































import { Component, Prop, Vue } from "vue-property-decorator";
import ContentRenderComponent from "@/components/render/ContentRender.vue";
import { RenderTemplateModel, RenderContentModel } from "@/services/render/types";
import { renderTemplate } from "@/services/render/renderService";
import { Getter } from "vuex-class";
import PreviewFullScreenHeader from "@/components/common/preview/PreviewFullScreenHeader.vue";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";

const namespace: string = "authentication";

@Component({
    components: {
        ContentRenderComponent,
        PreviewFullScreenHeader,
        PreviewSidebar
    }
})
export default class TemplatePreview extends Vue {
    @Prop() private templateId!: string;
    @Getter("getToken", { namespace }) getToken!: string;

    // local state
    contentRenderModel = {
        height: 0,
        width: 0,
        renderChannels: [] as Array<RenderContentModel>
    } as RenderTemplateModel;

    dateTime = "";
    contentRenderReload = 0;
    scale = 1;
    fitScale = 0;
    bgColor = "#ffffff";

    // lifecycle hooks
    created() {
        this.templateId = this.templateId
            ? this.templateId
            : this.$route.params.templateId;
    }

    // computed
    get model(): RenderTemplateModel {
        return this.contentRenderModel;
    }

    // methods
    renderTemplate(value: string, keepZoom = false) {
        this.dateTime = value;
        renderTemplate(this.templateId, this.dateTime).then(
            response => {
                this.contentRenderReload += 1;
                this.contentRenderModel = response;
                const oldScale = this.scale;
                this.setScale();
                if (keepZoom) this.scale = oldScale;
            }
        );
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 95) / this.contentRenderModel.width;
        var scaleY = (window.innerHeight / 100 * 85) / this.contentRenderModel.height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    onScale(value: number) {
        this.scale = value;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    // computed
    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.contentRenderModel.height}px`,
            width: `${this.contentRenderModel.width}px`
        };
    }
}
